<template>
  <div class="latestInfoEntry">
    <p class="timestamp"> Wednesday, June 20th 2012 </p>
    <img class="blogImage blogImage-right" src="../../assets/MT_Cover.jpg" />
    <h4>Midwifery Today Article</h4>

    <br />
    <p>The Four Pillars of Safe Breast Milk Sharing, an article written by Shell Walker Luttrell and Maria Armstrong, is featured the 2012 Spring edition of Midwifery Today.</p>
    <p><a href="http://eatsonfeets.org/docs/TheFourPillars.pdf" target="_blank">Click here to view it.</a>
  </p>
  <a href="https://pubmed.ncbi.nlm.nih.gov/22486021/" target="_blank">Pubmed Citation</a>
  <br />
  <br />
  <br />
  <br />
  <br />
  <br />
  <br />
  <br />
</div>
</template>

<script>
export default {
  name: 'MidwiferyTodayArticle'
}
</script>
